import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { DeviceProvider } from './contexts/DeviceContext';
import Login from './components/Login';
import DashboardLayout from './components/DashboardLayout';
import PrivateRoute from './components/PrivateRoute';
import {
  ControlsPage,
  WebsitesPage,
  ActionsPage,
  SchedulesPage,
  SettingsPage,
  MockupPage,
  TalkingpalPage,
  ExercisesPage,
} from './components/pages';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <DeviceProvider>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route
                path="/mockup"
                element={
                  <PrivateRoute>
                    <MockupPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DashboardLayout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="controls" replace />} />
                <Route path="controls" element={<ControlsPage />} />
                <Route path="websites" element={<WebsitesPage />} />
                <Route path="actions" element={<ActionsPage />} />
                <Route path="schedules" element={<SchedulesPage />} />
                <Route path="talkingpal" element={<TalkingpalPage />} />
                <Route path="exercises" element={<ExercisesPage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
            </Routes>
          </DeviceProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
